import React from 'react';
import styled from '@emotion/styled';
import { theme } from '@styles';
import { OUTER_SPACE } from '@constants';
import { limitStringCharacters } from '@utils';

const { breakpoints, maxWidth } = theme;

export type Item = {
  description: string;
  link?: string;
  title: string;
  thumbnail: string;
};

type Props = {
  items: Item[];
};

const ItemsGrid: React.FC<Props> = ({ items }) => {
  const renderItem = (item: Item, index: number) => {
    const { title } = item;
    const description = item.description.replace(/<[^>]*>?/gm, '');
    const { thumbnail } = item;
    const { link } = item;

    return (
      <Post key={index} href={link} target='_blank' rel='noref0errer'>
        <PostThumbnail width={83} height={83} src={thumbnail} alt={'Item preview image'} />
        <PostContent>
          <PostTitle dangerouslySetInnerHTML={{ __html: title }} />
          <PostDescription>{limitStringCharacters(description, 95)}</PostDescription>
        </PostContent>
      </Post>
    );
  };

  return <ItemsWrapper>{items.length && items.map((item, index) => renderItem(item, index))}</ItemsWrapper>;
};

export default ItemsGrid;

const ItemsWrapper = styled.div`
  display: grid;
  gap: 32px 0px;
  margin: 0 24px;
  @media screen and (min-width: ${breakpoints.smallLaptop}) {
    max-width: ${maxWidth};
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 48px 50px;
  }
`;

const PostThumbnail = styled.img`
  object-fit: cover;
  border-radius: 12px;
  margin-right: 16px;
  width: 64px;
  height: 64px;
  @media screen and (min-width: ${breakpoints.smallLaptop}) {
    width: 110px;
    height: 110px;
    margin-right: 24px;
  }
`;

const PostTitle = styled.div`
  font-family: 'Poppins';
  font-size: 20px;
  line-height: 26px;
  letter-spacing: -0.3px;
  font-weight: 700;
  color: ${OUTER_SPACE};
  @media screen and (min-width: ${breakpoints.smallLaptop}) {
    font-size: 20px;
    letter-spacing: -0.1px;
    line-height: 30px;
  }
`;

const PostDescription = styled.div`
  color: ${OUTER_SPACE};
  font-weight: 400;
  font-size: 16px;
  line-height: 20.8px;
  @media screen and (min-width: ${breakpoints.smallLaptop}) {
    display: initial;
    font-size: 16px;
    line-height: 24px;
  }
`;

const Post = styled.a<{ href: string | undefined }>`
  display: flex;
  align-items: flex-start;
  text-decoration: none;
  color: initial;
  &:hover {
    opacity: ${({ href }) => (href ? 0.8 : 1)};
  }
  @media screen and (min-width: ${breakpoints.smallLaptop}) {
    /* align-items: center; */
  }
`;

const PostContent = styled.div`
  display: flex;
  flex-direction: column;
`;
